import React from 'react';
import {observer} from 'mobx-react';
import {RenderV2_DisplayItem} from '../render-v2-d';
import './mat-secondary.scss';
import {inchToPx} from '../frame-builder';

type Props = {
    item: RenderV2_DisplayItem;
};

export const MatSecondary = observer(({item}: Props) => {
    const {width, height, url, mat2ImageURL, mat2Color} = item;
    const matSize = 0.3;
    const containerStyle: React.CSSProperties = {
        width: inchToPx(width),
        height: inchToPx(height),
    };

    if (mat2ImageURL) {
        const {cornerTopLeftURL, cornerTopRightURL, cornerBottomRightURL, cornerBottomLeftURL, sideLeftURL, sideRightURL, sideTopURL, sideBottomURL} = mat2ImageURL;
        const offset = inchToPx(matSize);
        const innerSize = `calc(100% - ${inchToPx(matSize * 2)})`;

        const img = (id: string, src: string, style: React.CSSProperties) => (
            <img
                key={id}
                id={id}
                src={src}
                alt={id.replace('mat2_', '').replace('_', ' ')}
                style={style}
            />
        );

        return (
            <div
                style={containerStyle}
                className="mat-image-container"
            >
                {(
                    [
                        ['mat2_top_left', cornerTopLeftURL, {top: 0, left: 0, width: inchToPx(matSize)}],
                        ['mat2_top_right', cornerTopRightURL, {top: 0, right: 0, width: inchToPx(matSize)}],
                        ['mat2_bottom_right', cornerBottomRightURL, {bottom: 0, right: 0, width: inchToPx(matSize)}],
                        ['mat2_bottom_left', cornerBottomLeftURL, {bottom: 0, left: 0, width: inchToPx(matSize)}],
                        ['mat2_left', sideLeftURL, {top: offset, left: 0, height: innerSize, width: inchToPx(matSize)}],
                        ['mat2_right', sideRightURL, {top: offset, right: 0, height: innerSize, width: inchToPx(matSize)}],
                        ['mat2_top', sideTopURL, {top: 0, left: offset, width: innerSize, height: inchToPx(matSize)}],
                        ['mat2_bottom', sideBottomURL, {bottom: 0, left: offset, width: innerSize, height: inchToPx(matSize)}],
                    ] as [string, string, React.CSSProperties][]
                ).map(([id, src, style]) =>
                    img(id, src, {
                        position: 'absolute',
                        height: 'fit-content',
                        ...style,
                    }),
                )}

                <img
                    id="document"
                    src={url}
                    alt="Document"
                    style={{
                        width: inchToPx(width - matSize * 2),
                        height: inchToPx(height - matSize * 2),
                        top: offset,
                        left: offset,
                        position: 'absolute',
                    }}
                />
            </div>
        );
    }

    const box = (cls: string, w: number, h: number, extra?: React.CSSProperties) => (
        <div
            key={cls}
            className={cls}
            style={{width: inchToPx(w), height: inchToPx(h), ...extra}}
        />
    );

    return (
        <div
            style={{width: inchToPx(width - matSize * 2), height: inchToPx(height - matSize * 2)}}
            className="frame-doc-container"
        >
            {box('mat2-outer', width, height, {top: inchToPx(-matSize / 2), left: inchToPx(-matSize / 2)})}
            {box('mat2-width', width - matSize + 0.2, height - matSize + 0.2, {backgroundColor: mat2Color, top: inchToPx(-0.1), left: inchToPx(-0.1)})}
            {box('mat2-inner', width - matSize - 0.18, height - matSize - 0.18, {top: inchToPx(0.09), left: inchToPx(0.09)})}

            <img
                src={url}
                alt="Document"
                style={{
                    width: inchToPx(width - matSize * 2),
                    height: inchToPx(height - matSize * 2),
                    top: inchToPx(0.15),
                    left: inchToPx(0.15),
                }}
            />
            {box('mat2-box', width - matSize * 2, height - matSize * 2, {top: inchToPx(0.15), left: inchToPx(0.15)})}
        </div>
    );
});
